




















































import mixins from 'vue-typed-mixins'
import DraftElement from '@/builder/sections/mixins/DraftElement'
import VCardWrapper from '@/builder/sections/section/calendars/components/VCardWrapper.vue'

export default mixins(DraftElement).extend({
  components: { VCardWrapper },
  props: {
    textColor: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: null
    },
    classForViewRound: {
      type: String,
      default: ''
    },
    changeMode: {
      type: Boolean,
      default: false
    }
  }
})
